import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";

const BankMasterGrid = () => {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchGridData = async () => {
    try {
      const response = await apiFetch(
        "//144.143.142.29:5000/api/bankmaster/grid",
      );
      const data = await response.json();
      setGridData(data);
      setFilteredData(data);
    } catch (err) {
      console.error("❌ Error fetching Bank Master grid:", err);
      alert("Unable to fetch data from backend.");
    }
  };

  useEffect(() => {
    fetchGridData();
  }, []);

  const handleSearch = async () => {
    try {
      const response = await apiFetch(
        `//144.143.142.29:5000/api/bankmaster/search?q=${encodeURIComponent(
          searchTerm,
        )}`,
      );
      const data = await response.json(); // 🔥 IMPORTANT
      setFilteredData(data || []);
      setCurrentPage(1);
    } catch (err) {
      console.error("❌ Error searching Bank Master:", err);
      alert("Unable to fetch search results from backend.");
    }
  };

  const handleEdit = async (id) => {
    try {
      const res = await apiFetch(
        `//144.143.142.29:5000/api/bankmaster/edit/${id}`,
      );

      // ✅ check response
      if (!res.ok) {
        const errText = await res.text();
        console.error("EDIT FETCH ERROR:", errText);
        alert("Failed to fetch record!");
        return;
      }

      const fullData = await res.json();

      // ✅ safety check
      if (!fullData || Object.keys(fullData).length === 0) {
        alert("⚠️ No record found for this ID.");
        return;
      }

      // ✅ navigate with data
      navigate("/Bank", { state: { editData: fullData } });
    } catch (err) {
      console.error("❌ Failed to fetch record:", err);
      alert("Unable to fetch record. Please check backend or network.");
    }
  };

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      const res = await fetch(
        `//144.143.142.29:5000/api/bankmaster/delete/${id}`,
        {
          method: "DELETE",
        },
      );

      const data = await res.json();
      console.log("Delete response:", data);
      alert(data.message);
      if (data.message === "Deleted successfully") {
        setGridData((prev) => prev.filter((row) => row.uniqueId !== id));
        setFilteredData((prev) => prev.filter((row) => row.uniqueId !== id));
      }
    } catch (err) {
      console.error("Failed to delete record:", err);
      alert("Unable to delete record. Check backend.");
    }
  }

  const totalPages = Math.ceil(filteredData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);

  /*------------------ Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "calc(100vh - 70px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "16px",
    backgroundColor: "#f4f6f8",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "16px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  const headerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  };
  const leftHeaderStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: "250px",
  };
  const titleStyle = {
    fontSize: "1.2rem",
    fontWeight: "bold",
    flexShrink: 0,
  };
  const addButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#3a28a0ff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const searchInputStyle = {
    flex: "1 1 250px",
    maxWidth: "450px",
    minWidth: "200px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };
  const searchButtonStyle = {
    padding: "8px 12px",
    backgroundColor: "#2196F3",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const selectStyle = {
    padding: "8px 10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    whiteSpace: "nowrap",
  };
  const tableWrapperStyle = { overflowX: "auto" };
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "400px",
  };
  const thStyle = {
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#8B1E3F",
    color: "#fff",
    border: "1px solid #ddd",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
  };
  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    wordWrap: "break-word",
    fontSize: "0.85rem",
  };
  const actionButtonStyle = (bgColor) => ({
    padding: "6px 10px",
    marginRight: "5px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    minWidth: "60px",
    fontSize: "0.8rem",
  });
  const paginationStyle = {
    marginTop: "12px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.9rem",
  };
  const pageBtnStyle = {
    padding: "6px 12px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "#f9f9f9",
    fontSize: "0.85rem",
  };

  return (
    <Layout>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <div style={titleStyle}>Bank Master Grid</div>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={searchInputStyle}
            />
            <button style={searchButtonStyle} onClick={handleSearch}>
              Search
            </button>
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              {[10, 20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size} / page
                </option>
              ))}
            </select>
          </div>
          <button style={addButtonStyle} onClick={() => navigate("/Bank")}>
            Add New
          </button>
        </div>

        <div style={tableWrapperStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Bank Name</th>
                <th style={thStyle}>Account No</th>
                <th style={thStyle}>Account Name</th>
                <th style={thStyle}>Abbreviation</th>
                <th style={thStyle}>Type</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((row) => (
                  <tr key={row.uniqueId}>
                    <td style={tdStyle}>{row.bankName}</td>
                    <td style={tdStyle}>{row.accountNo}</td>
                    <td style={tdStyle}>{row.accountName}</td>
                    <td style={tdStyle}>{row.abbreviation}</td>
                    <td style={tdStyle}>{row.type}</td>
                    <td style={tdStyle}>
                      <button
                        style={{
                          ...pageBtnStyle,
                          backgroundColor: "#4CAF50",
                          color: "#fff",
                          marginRight: "5px",
                        }}
                        onClick={() => handleEdit(row.uniqueId)}
                      >
                        Edit
                      </button>
                      {
                        <button
                          style={{
                            ...pageBtnStyle,
                            backgroundColor: "#f44336",
                            color: "#fff",
                          }}
                          onClick={() => handleDelete(row.uniqueId)} // must match SP
                        >
                          Delete
                        </button>
                      }
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={tdStyle}>
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div style={paginationStyle}>
          <button
            style={pageBtnStyle}
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>
          <span>
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            style={pageBtnStyle}
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default BankMasterGrid;
